import { Injectable } from '@angular/core';
import { UserDetailsResponse } from '../auth.service';
import { BehaviorSubject } from 'rxjs';
import { GroupedLookups } from '../../core/services/lookup.service';

const USER_INFO = 'user_info';

@Injectable({ providedIn: 'root' })
export class AuthContext {
    private userInfoSubject = new BehaviorSubject<UserDetailsResponse | null>(this.getUserInfo());
    public userInfo$ = this.userInfoSubject.asObservable();

    private lookUpSubject = new BehaviorSubject<GroupedLookups | null>(this.getLookups());
    public lookUpValue$ = this.lookUpSubject.asObservable();
    
    private _isAuthenticated: boolean;

    constructor() {
        this._isAuthenticated = Boolean(localStorage.getItem('userLoggedIn'));
    }

    setAuthenticated(): void {
        this._isAuthenticated = true;
        localStorage.setItem('userLoggedIn', 'true');
    }

    removeIsAuthenticated(): void {
        this._isAuthenticated = false;
        localStorage.removeItem('userLoggedIn');
    }

    public get isAuthenticated(): boolean {
        return this._isAuthenticated;
    }

    getUserInfo(): UserDetailsResponse {
        return JSON.parse(localStorage.getItem(USER_INFO) as string);
    }

    setUserInfo(userInfo: UserDetailsResponse) {
        localStorage.setItem(USER_INFO, JSON.stringify(userInfo));
        this.userInfoSubject.next(userInfo); // Notify subscribers
    }

    // Simulate storing the token (could be set during login)
    setToken(token: string) {
        localStorage.setItem('accessToken', token);
    }

    // Retrieve the token when needed
    getToken(): string | null {
        return localStorage.getItem('accessToken'); // Return the token or an empty string
    }

    // Storing the lookups
    setLookups(lookups: GroupedLookups) {
        localStorage.setItem('lookups', JSON.stringify(lookups));
    }

    // Getting the lookups
    getLookups(): GroupedLookups {
        return JSON.parse(localStorage.getItem('lookups') as string);
    }
}